var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagnosticScoreGlobal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.5824,
    height: 21.9998,
    viewBox: "0 0 21.5824 21.9998",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9706 14.4719V21.6561C17.9706 21.8623 17.8331 21.9998 17.6268 21.9998H1.57271C1.36645 21.9998 1.22894 21.8623 1.22894 21.6561C1.22894 21.4842 1.36645 21.3124 1.57271 21.3124H6.96991V18.1843C6.96991 17.9781 7.1418 17.8406 7.31368 17.8406H12.814V14.4719C12.814 14.3 12.9859 14.1281 13.1578 14.1281H17.6268C17.7987 14.1281 17.9706 14.2656 17.9706 14.4719Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5661 10.245V13.4418H14.8786V10.4168L15.5661 10.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.5821 1.09998V5.43113C21.5821 5.56863 21.5134 5.67175 21.3759 5.7405C21.2727 5.80925 21.1009 5.77487 21.0321 5.70612C19.382 4.43428 17.5944 6.90922 15.5661 6.04987V6.84047C15.463 6.84047 15.3599 6.8061 15.2911 6.8061C15.1536 6.8061 15.0161 6.8061 14.8786 6.87485V0.343742C14.8786 0.171871 15.0505 0 15.2224 0C15.4286 0 15.5661 0.171871 15.5661 0.343742V0.928105C16.3568 1.44372 17.1819 1.13435 18.11 0.790608C19.1414 0.378117 20.3102 -0.0687485 21.4446 0.859356C21.5134 0.89373 21.5821 0.996853 21.5821 1.09998Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.70968 3.98749C4.70968 2.85314 5.63786 1.92504 6.7723 1.92504C7.90674 1.92504 8.83493 2.85314 8.83493 3.98749C8.83493 5.12184 7.90674 6.04994 6.7723 6.04994C5.63786 6.04994 4.70968 5.12184 4.70968 3.98749Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.6059 9.52053L12.0307 10.4486C11.3088 10.6893 10.4493 10.5861 9.79617 10.1049L8.76486 9.38303L8.6961 12.0642L10.5181 12.5111C11.3775 12.7173 12.0307 13.4392 12.1682 14.2642C12.1338 14.436 12.1682 14.3329 12.1338 17.1172H9.69304V15.5016C9.69304 15.2954 9.55553 15.1235 9.34927 15.0548L7.25227 14.6079C7.14914 15.2267 7.59604 12.4423 6.32409 20.4859V20.589H3.84894C3.81456 20.4859 3.81456 20.3828 3.84894 20.2797L4.57086 13.1986C4.43335 12.9236 4.36459 12.6486 4.36459 12.3392V9.34866L2.95513 10.8955C2.95513 10.8955 2.92076 10.9299 2.92076 10.9642L2.19884 13.3017C2.06133 13.7486 1.64881 14.0579 1.16753 14.0923C0.376854 14.0923 -0.138802 13.3704 0.0330833 12.683L0.617493 10.3799C0.65187 10.2424 0.720625 10.1393 0.789379 10.0361L3.36766 7.01121C3.78018 6.52997 4.36459 6.28935 4.98338 6.32373L8.31796 6.52997C9.31489 6.59872 9.69304 7.25183 10.8619 8.11119C11.1713 8.35181 11.5494 8.42056 11.9275 8.28306L15.0215 7.52683C15.5715 7.35495 16.2247 7.6987 16.3278 8.35181C16.3966 8.86742 16.0872 9.34866 15.6059 9.52053Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosticScoreGlobal);
export default __webpack_public_path__ + "static/media/diagnostic-score-global.e99e5d4b674405b0289b87e091415d35.svg";
export { ForwardRef as ReactComponent };